import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import {
  api, API, getCustomer, clearCustomer, fmtTRY,
} from "@/lib/api";
import { WORKSPACE, MANUAL_MATCH } from "@/constants/testIds";
import {
  Calculator, FileSpreadsheet, FileText, Download, RotateCcw, LogOut,
PackageSearch, CircleCheck, CircleAlert, Sparkles, Upload, Search, Wand2,
Plus, Trash2, Camera, Send, Pencil,
} from "lucide-react";

// V17.23: telefonda sayfa yenilense de hazırlanan teklif kaybolmasın (ilerleme kimliği tarayıcıda saklanır).
const SERIF = "'Fraunces', 'Libre Caslon Text', Georgia, 'Times New Roman', serif";
const WS_LOGO = "data:image/png;base64,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";
// 17.35: dövizli ürün notu
const FX_SYM = { USD: "$", EUR: "€" };
const fxMoney = (cur, v) => `${FX_SYM[cur] || cur} ${Number(v || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fxSummary = (items) => {
  const out = {};
  (items || []).forEach((it) => { const fx = it?.fx; if (fx?.rate && it.matched && (!out[fx.cur] || String(fx.date) >= String(out[fx.cur].date))) out[fx.cur] = fx; });
  return Object.keys(out).map((c) => `1 ${c} = ${Number(out[c].rate).toLocaleString("tr-TR", { minimumFractionDigits: 4, maximumFractionDigits: 4 })} TL`).join(" · ")
    + (Object.keys(out).length ? ` (${new Date(out[Object.keys(out)[0]].date).toLocaleDateString("tr-TR")})` : "");
};
const PENDING_KEY = "pramid_pending_quote_v1";
const PENDING_MAX_MS = 2 * 60 * 60 * 1000;
const readPending = () => {
  try { return JSON.parse(window.localStorage.getItem(PENDING_KEY) || "null"); } catch { return null; }
};
const writePending = (value) => {
  try {
    if (value) window.localStorage.setItem(PENDING_KEY, JSON.stringify(value));
    else window.localStorage.removeItem(PENDING_KEY);
  } catch { /* gizli sekme vb.: yalnız yenilemede geri getirme çalışmaz */ }
};

// 17.39: telefon doğrulama anahtarı (giriş sayfasında alınır) her isteğe eklenir
const SESSION_KEY = "pramid_session";
function applySession() {
  try {
    const t = window.localStorage.getItem(SESSION_KEY);
    if (api?.defaults?.headers?.common) {
      if (t) api.defaults.headers.common["X-Pramid-Session"] = t;
      else delete api.defaults.headers.common["X-Pramid-Session"];
    }
    return t || "";
  } catch { return ""; }
}
applySession();

const SAMPLE = `50 metre pprc boru 25
100 metre boru 32
20 adet küresel vana 3/4
15 adet panel radyatör 60x100
10 adet premix kombi 24 kw`;

export default function Workspace() {
  const nav = useNavigate();
  const customer = getCustomer();
  const [tab, setTab] = useState("text");
  const [text, setText] = useState("");
  const [file, setFile] = useState(null);
  const [photoFiles, setPhotoFiles] = useState([]);
  const [pdfFile, setPdfFile] = useState(null);
  const [ocrLoading, setOcrLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [quote, setQuote] = useState(null);
  const [brands, setBrands] = useState([]);
  const [matchIdx, setMatchIdx] = useState(null); // index of unmatched row to fix
  const [extraItems, setExtraItems] = useState([]);
  const [requestingItem, setRequestingItem] = useState(null);
  const [adminNoteTarget, setAdminNoteTarget] = useState(null);
  const [adminNote, setAdminNote] = useState("");
  const [quoteProgress, setQuoteProgress] = useState(null);
  const [resuming, setResuming] = useState(false);
  // 17.39: doğrulama zorunluysa ve bu cihaz doğrulanmamışsa giriş sayfasına dön; "Tekliflerim"
  const [sessionOk, setSessionOk] = useState(false);
  const [myOpen, setMyOpen] = useState(false);
  const [myQuotes, setMyQuotes] = useState(null);
  useEffect(() => {
    if (!customer?.id) return;
    applySession();
    api.get("/customer-session", { params: { customer_id: customer.id } }).then((r) => {
      if (r.data?.required && !r.data?.valid) {
        try { window.localStorage.removeItem(SESSION_KEY); } catch { /* yok say */ }
        applySession();
        clearCustomer();
        toast("Güvenliğiniz için telefonunuzu bir kez WhatsApp ile doğrulayın.");
        nav("/");
        return;
      }
      setSessionOk(!!r.data?.valid);
    }).catch(() => {});
  }, [customer?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const openMyQuotes = async () => {
    setMyOpen(true);
    setMyQuotes(null);
    try { const r = await api.get("/my-quotes"); setMyQuotes(r.data?.quotes || []); }
    catch { setMyQuotes([]); toast.error("Teklifleriniz yüklenemedi."); }
  };
  const openMyQuote = async (id) => {
    try {
      const r = await api.get(`/quotes/${id}`);
      setQuote(r.data);
      setMyOpen(false);
    } catch { toast.error("Teklif açılamadı."); }
  };
  // 17.33: giriş sayfasıyla aynı başlık yazı tipi (Fraunces)
  useEffect(() => {
    if (document.getElementById("pramid-serif-font")) return;
    const link = document.createElement("link");
    link.id = "pramid-serif-font";
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600&display=swap";
    document.head.appendChild(link);
  }, []);
  const [isDesktop, setIsDesktop] = useState(() => typeof window === "undefined" || !window.matchMedia || window.matchMedia("(min-width: 1024px)").matches);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia("(min-width: 1024px)");
    const on = () => setIsDesktop(mq.matches);
    on();
    if (mq.addEventListener) mq.addEventListener("change", on); else mq.addListener(on);
    return () => { if (mq.removeEventListener) mq.removeEventListener("change", on); else mq.removeListener(on); };
  }, []);
  // Telefonda teklif gelince sonuçlara kaydır (giriş kutusunun altında kalmasın).
  useEffect(() => {
    if (!quote?.id || isDesktop) return;
    const el = document.getElementById("ws-results");
    if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
  }, [quote?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const progressTimerRef = useRef(null);

  useEffect(() => {
    if (!customer) return;
    api.get("/brands").then((r) => setBrands(r.data)).catch(() => {});
  }, [customer?.id]);

  useEffect(() => () => {
    if (progressTimerRef.current) clearInterval(progressTimerRef.current);
  }, []);

  // V17.23: sayfa yeniden açıldığında yarım kalan teklif varsa ilerlemeyi izle, bitince teklifi getir.
  useEffect(() => {
    if (!customer) return;
    const pending = readPending();
    if (!pending || !pending.id) return;
    if (pending.customerId !== customer.id || Date.now() - Number(pending.startedAt || 0) > PENDING_MAX_MS) {
      writePending(null);
      return;
    }
    setResuming(true);
    setQuoteProgress({ percent: 1, stage: "Teklif hazırlanıyor", detail: "Sayfa yenilendi; teklif takip ediliyor" });
    let stop = false;
    const tick = async () => {
      if (stop) return;
      try {
        const r = await api.get(`/quote-progress/${pending.id}`);
        const row = r.data || {};
        if (row.quote_id) {
          const q = await api.get(`/quotes/${row.quote_id}`);
          if (stop) return;
          setQuote(q.data);
          if (q.data?.ocr_text) setText(q.data.ocr_text);
          writePending(null);
          setResuming(false);
          setQuoteProgress(null);
          toast.success(`${q.data?.items?.length || 0} kalemlik teklif hazır.`);
          return;
        }
        if (row.failed || row.error) {
          writePending(null);
          setResuming(false);
          setQuoteProgress(null);
          toast.error(row.failed_detail || "Teklif oluşturulamadı.");
          return;
        }
        setQuoteProgress({
          percent: Math.max(1, Math.min(100, Number(row.percent || 0))),
          stage: row.stage || "İşleniyor",
          detail: row.detail || "",
        });
      } catch {
        // Bağlantı kesildiyse tekrar dene.
      }
      if (!stop && Date.now() - Number(pending.startedAt || 0) <= PENDING_MAX_MS) {
        setTimeout(tick, 1500);
      } else if (!stop) {
        writePending(null);
        setResuming(false);
        setQuoteProgress(null);
      }
    };
    tick();
    return () => { stop = true; };
  }, [customer?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const stopProgressPolling = () => {
    if (progressTimerRef.current) {
      clearInterval(progressTimerRef.current);
      progressTimerRef.current = null;
    }
  };

  const beginProgress = (stage = "Başlatılıyor") => {
    stopProgressPolling();
    const id = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    setQuoteProgress({ percent: 1, stage, detail: "" });
    writePending({ id, customerId: customer?.id, startedAt: Date.now() });
    progressTimerRef.current = setInterval(async () => {
      try {
        const r = await api.get(`/quote-progress/${id}`);
        const row = r.data || {};
        setQuoteProgress({
          percent: Math.max(1, Math.min(100, Number(row.percent || 0))),
          stage: row.stage || "İşleniyor",
          detail: row.detail || "",
        });
        if (row.done) stopProgressPolling();
      } catch {
        // Backend kaydı oluşana kadar tekrar dene.
      }
    }, 450);
    return id;
  };

  const keepPendingRef = useRef(false);
  const finishProgress = (ok = true) => {
    stopProgressPolling();
    if (!keepPendingRef.current) writePending(null);
    keepPendingRef.current = false;
    if (ok) {
      setQuoteProgress((prev) => ({ ...(prev || {}), percent: 100, stage: "Tamamlandı", detail: "Teklif hazır" }));
      setTimeout(() => setQuoteProgress(null), 1200);
    } else {
      setQuoteProgress(null);
    }
  };

  if (!customer) return null;

  // 17.34: uzun listede bağlantı süresi dolarsa (sunucu ara katmanı ~5 dk) teklif sunucuda hazırlanmaya devam eder.
  // Hata yerine ilerleme izlenir; teklif bitince ekrana gelir. undefined = bekleme gerektirmeyen gerçek hata.
  const recoverQuote = async (e, id) => {
    const st = Number(e?.response?.status || 0);
    if (e?.response && st !== 502 && st !== 503 && st !== 504) return undefined;
    stopProgressPolling();
    const started = Date.now();
    while (Date.now() - started < 20 * 60 * 1000) {
      await new Promise((res) => setTimeout(res, 3000));
      try {
        const r = await api.get(`/quote-progress/${id}`);
        const row = r.data || {};
        if (row.quote_id) {
          const q = await api.get(`/quotes/${row.quote_id}`);
          return q.data;
        }
        if (row.failed || row.error) {
          toast.error(row.failed_detail || "Teklif oluşturulamadı.");
          return null;
        }
        setQuoteProgress({
          percent: Math.max(1, Math.min(99, Number(row.percent || 0))),
          stage: row.stage || "Teklif hazırlanıyor",
          detail: "Uzun liste; sonuç bekleniyor, lütfen sayfayı kapatmayın",
        });
      } catch {
        // bağlantı gelince tekrar dene
      }
    }
    keepPendingRef.current = true;
    toast.error("Teklifiniz hâlâ hazırlanıyor; birkaç dakika sonra bu sayfayı yenileyin.");
    return null;
  };
  const applyRecovered = (q) => {
    setQuote(q);
    if (q?.ocr_text) setText(q.ocr_text);
    toast.success(`${q?.items?.length || 0} kalem fiyatlandırıldı.`);
  };

  const logout = () => {
    api.post("/customer-session/logout").catch(() => {});
    try { window.localStorage.removeItem(SESSION_KEY); } catch { /* yok say */ }
    applySession();
    clearCustomer();
    nav("/");
  };

  const reset = () => {
  setQuote(null);
  setText("");
  setFile(null);
  setPhotoFiles([]);
  setPdfFile(null);
  setExtraItems([]);
  stopProgressPolling();
  setQuoteProgress(null);
  setResuming(false);
  writePending(null);
};

  const calculate = async () => {
    const lines = text.split("\n").map((l) => l.trim()).filter(Boolean);
    if (lines.length === 0) {
      toast.error("Lütfen en az bir ürün satırı girin.");
      return;
    }
    setLoading(true);
    const progressId = beginProgress("Teklif hazırlanıyor");
    let ok = false;
    try {
      const res = await api.post("/quotes", { customer_id: customer.id, lines }, {
        headers: { "X-Progress-Id": progressId },
      });
      setQuote(res.data);
      ok = true;
      toast.success(`${res.data.items.length} kalem fiyatlandırıldı.`);
    } catch (e) {
      const rq = await recoverQuote(e, progressId);
      if (rq) { applyRecovered(rq); ok = true; }
      else if (rq === undefined) toast.error(e?.response?.data?.detail || "Hesaplama hatası.");
    } finally {
      finishProgress(ok);
      setLoading(false);
    }
  };

const uploadExcel = async () => {
  if (!file) {
    toast.error("Lütfen bir Excel dosyası seçin.");
    return;
  }
  setLoading(true);
  const progressId = beginProgress("Excel hazırlanıyor");
  let ok = false;
  try {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("customer_id", customer.id);
    const res = await api.post("/quotes/excel", fd, {
      headers: { "Content-Type": "multipart/form-data", "X-Progress-Id": progressId },
    });
    setQuote(res.data);
    ok = true;
    toast.success(`${res.data.items.length} kalem fiyatlandırıldı.`);
  } catch (e) {
    const rq = await recoverQuote(e, progressId);
      if (rq) { applyRecovered(rq); ok = true; }
      else if (rq === undefined) toast.error(e?.response?.data?.detail || "Excel okunamadı.");
  } finally {
    finishProgress(ok);
    setLoading(false);
  }
};

  const addPhotoFiles = (event) => {
    const selected = Array.from(event.target.files || []).filter((f) =>
      String(f.type || "").startsWith("image/")
    );

    if (!selected.length) {
      toast.error("Lütfen geçerli fotoğraf dosyaları seçin.");
      return;
    }

    const existingKeys = new Set(
      photoFiles.map((f) => `${f.name}::${f.size}::${f.lastModified}`)
    );
    const merged = [...photoFiles];

    for (const f of selected) {
      const key = `${f.name}::${f.size}::${f.lastModified}`;
      if (!existingKeys.has(key)) {
        merged.push(f);
        existingKeys.add(key);
      }
    }

    if (merged.length > 20) {
      toast.warning("Tek seferde en fazla 20 fotoğraf yüklenebilir. İlk 20 fotoğraf alındı.");
    }

    setPhotoFiles(merged.slice(0, 20));
    // Aynı dosyanın sonradan yeniden seçilebilmesi için input'u temizle.
    event.target.value = "";
  };

  const removePhotoFile = (index) => {
    setPhotoFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const uploadPhoto = async () => {
    if (!photoFiles.length) {
      toast.error("Lütfen en az bir fotoğraf seçin.");
      return;
    }
    setOcrLoading(true);
    const progressId = beginProgress("Fotoğraflar hazırlanıyor");
    let ok = false;
    try {
      const fd = new FormData();
      photoFiles.forEach((photo) => fd.append("files", photo));
      fd.append("customer_id", customer.id);
      const res = await api.post("/quotes/photos", fd, {
        headers: { "Content-Type": "multipart/form-data", "X-Progress-Id": progressId },
      });
      setQuote(res.data);
      setText(res.data.ocr_text || res.data.lines?.join("\n") || "");
      const sourceCount = Number(res.data.source_count || photoFiles.length);
      ok = true;
      toast.success(`${sourceCount} fotoğraftan toplam ${res.data.items.length} kalem fiyatlandırıldı.`);
    } catch (e) {
      const rq = await recoverQuote(e, progressId);
      if (rq) { applyRecovered(rq); ok = true; }
      else if (rq === undefined) toast.error(e?.response?.data?.detail || "Fotoğraflardan teklif oluşturulamadı.");
    } finally {
      finishProgress(ok);
      setOcrLoading(false);
    }
  };

const uploadPdf = async () => {
  if (!pdfFile) {
    toast.error("Lütfen bir PDF dosyası seçin.");
    return;
  }
  setPdfLoading(true);
  const progressId = beginProgress("PDF hazırlanıyor");
  let ok = false;
  try {
    const fd = new FormData();
    fd.append("file", pdfFile);
    fd.append("customer_id", customer.id);
    const res = await api.post("/quotes/pdf", fd, {
      headers: { "Content-Type": "multipart/form-data", "X-Progress-Id": progressId },
    });
    setQuote(res.data);
    setText(res.data.ocr_text || res.data.lines?.join("\n") || "");
    ok = true;
    toast.success(`${res.data.items.length} kalem PDF'den fiyatlandırıldı.`);
  } catch (e) {
    const rq = await recoverQuote(e, progressId);
      if (rq) { applyRecovered(rq); ok = true; }
      else if (rq === undefined) toast.error(e?.response?.data?.detail || "PDF'den teklif oluşturulamadı.");
  } finally {
    finishProgress(ok);
    setPdfLoading(false);
  }
};


 const downloadPdf = async (mode = "nakit") => {
  if (!quote) return;
  if (quote.summary?.is_draft) {
    toast.warning("Teklif henüz tamamlanmadı. PDF taslak olarak, yalnız mevcut eşleşme/fiyatlarla hazırlanacak.");
  }

  try {
    await fetch(`${API}/quotes/${quote.id}/extra-items`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        extra_items: extraItems.map((item) => ({
          description: item.description || "",
          amount: Number(item.amount || 0),
        })),
      }),
    });

    window.open(
      `${API}/quotes/${quote.id}/pdf?mode=${mode}`,
      "_blank"
    );
  } catch (err) {
    console.error(err);
    alert("Ek kalemler kaydedilemedi.");
  }
};

const downloadExcel = (mode = "nakit") => {
  if (!quote) return;
  if (quote.summary?.is_draft) {
    toast.warning("Teklif henüz tamamlanmadı. Excel taslak olarak mevcut kalemlerle indirilecek.");
  }
  window.open(`${API}/quotes/${quote.id}/excel?mode=${mode}`, "_blank");
};

const openAdminNote = (itemIdx) => {
  if (!quote || typeof itemIdx !== "number") return;
  setAdminNoteTarget(itemIdx);
  setAdminNote("");
};

// 17.25: müşteri miktarı değiştirebilir (admine gönderilen satır / teklif kilitli; sunucu da kontrol eder)
const saveItemQty = async (itemIdx, qty) => {
  if (!quote) return false;
  const item = quote.items?.[itemIdx];
  try {
    const res = await api.patch(`/quotes/${quote.id}/items/${itemIdx}/qty`, {
      qty, source_text: item?.source_text || item?.searched || "",
    });
    setQuote(res.data);
    toast.success("Miktar güncellendi.");
    return true;
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Miktar güncellenemedi.");
    return false;
  }
};

const requestItemAdmin = async () => {
  const itemIdx = adminNoteTarget;
  if (!quote || typeof itemIdx !== "number") return;
  setRequestingItem(itemIdx);
  try {
    const res = await api.post(`/quotes/${quote.id}/items/${itemIdx}/request-admin`, { note: adminNote || "" });
    setQuote(res.data);
    const row = res.data?.items?.[itemIdx];
    toast.success(row?.admin_request_type === "price"
      ? "Bu ürün için fiyat talebi admine iletildi."
      : "Bu ürün admin eşleştirme kuyruğuna gönderildi.");
    setAdminNoteTarget(null);
    setAdminNote("");
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Ürün admine gönderilemedi.");
  } finally {
    setRequestingItem(null);
  }
};

const addExtraItem = () => {
  setExtraItems((prev) => [
    ...prev,
    { description: "", amount: "" },
  ]);
};

const updateExtraItem = (index, field, value) => {
  setExtraItems((prev) =>
    prev.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    )
  );
};

const removeExtraItem = (index) => {
  setExtraItems((prev) => prev.filter((_, i) => i !== index));
};

const extraTotal = extraItems.reduce(
  (sum, item) => sum + Number(String(item.amount || "0").replace(",", ".")),
  0
);

const cashGrandTotal = (quote?.totals?.cash || 0) + extraTotal;
const cardGrandTotal = (quote?.totals?.card || 0) + extraTotal;


  // 17.31: dışa aktarma kartı bilgisayarda solda, telefonda sonuçların altında (tek yerde çizilir).
  const exportCard = quote ? (
              <Card className="border-[#E6E0D6] shadow-sm rounded-lg p-5">
                <div className="text-[11px] uppercase tracking-[0.15em] text-[#4B5563] mb-3">
                  Dışa Aktarma
                </div>
                <div data-testid={WORKSPACE.totalsList} className="mb-4 space-y-2">
  <TotalRow label="Ürün Nakit Toplam" value={quote.totals.cash} />
  <TotalRow label="Ürün Kart Toplam" value={quote.totals.card} />

  {extraTotal > 0 && (
    <>
      <Separator className="my-3 bg-[#E6E0D6]" />
      <TotalRow label="Ek Kalem Toplamı" value={extraTotal} />
    </>
  )}

  <Separator className="my-3 bg-[#E6E0D6]" />

  <TotalRow
    label="Genel Nakit Toplam"
    value={cashGrandTotal}
    accent
    testId={WORKSPACE.totalsCash}
  />

  <TotalRow
    label="Genel Kart Toplam"
    value={cardGrandTotal}
    testId={WORKSPACE.totalsCard}
  />
</div>
                <Separator className="my-4 bg-[#E6E0D6]" />
                <div className="text-[10px] uppercase tracking-[0.15em] text-[#4B5563] mb-2">Nakit fiyat teklifi</div>
                <div className="grid grid-cols-2 gap-2">
                  <Button
                    data-testid={WORKSPACE.exportPdfBtn}
                    onClick={() => downloadPdf("nakit")}
                    title={quote.summary?.is_draft ? "Taslak PDF indir — eksik/fiyatsız kalemler olabilir" : "Nakit fiyat teklifi PDF"}
                    className="bg-[#0F1B2D] hover:bg-[#1B2B44] text-white text-xs uppercase tracking-wide h-10"
                  >
                    <Download className="w-3.5 h-3.5 mr-1.5" /> Nakit PDF
                  </Button>
                  <Button
                    data-testid={WORKSPACE.exportExcelBtn}
                    onClick={() => downloadExcel("nakit")}
                    title="Nakit fiyat teklifi Excel"
                    variant="outline"
                    className="border-[#E6E0D6] text-[#0F1B2D] hover:bg-[#F1ECE4] text-xs uppercase tracking-wide h-10"
                  >
                    <Download className="w-3.5 h-3.5 mr-1.5" /> Nakit Excel
                  </Button>
                </div>
                <div className="text-[10px] uppercase tracking-[0.15em] text-[#4B5563] mt-4 mb-2">Kredi kartı taksitli fiyat teklifi</div>
                <div className="grid grid-cols-2 gap-2">
                  <Button
                    onClick={() => downloadPdf("kart")}
                    title={quote.summary?.is_draft ? "Taslak PDF indir — eksik/fiyatsız kalemler olabilir" : "Kredi kartı taksitli fiyat teklifi PDF"}
                    className="bg-[#334155] hover:bg-[#1F2937] text-white text-xs uppercase tracking-wide h-10"
                  >
                    <Download className="w-3.5 h-3.5 mr-1.5" /> Kart PDF
                  </Button>
                  <Button
                    onClick={() => downloadExcel("kart")}
                    title="Kredi kartı taksitli fiyat teklifi Excel"
                    variant="outline"
                    className="border-[#E6E0D6] text-[#0F1B2D] hover:bg-[#F1ECE4] text-xs uppercase tracking-wide h-10"
                  >
                    <Download className="w-3.5 h-3.5 mr-1.5" /> Kart Excel
                  </Button>
                </div>
                <Button
                  data-testid={WORKSPACE.newQueryBtn}
                  variant="ghost"
                  onClick={reset}
                  className="w-full mt-3 text-[#4B5563] hover:text-[#0F1B2D] hover:bg-[#F1ECE4] text-xs"
                >
                  <RotateCcw className="w-3.5 h-3.5 mr-1.5" /> Yeni Sorgu
                </Button>
              </Card>
  ) : null;

  const busyItem = (it) => it.admin_requested_by_customer && !["completed", "cancelled"].includes(it.admin_request_status);
  const itemActions = (it, i) => (
    <div className="flex items-center gap-1.5 shrink-0 flex-wrap justify-end">
      <button
        data-testid={`${MANUAL_MATCH.openBtn}-${i}`}
        onClick={() => setMatchIdx(i)}
        className="text-[10px] uppercase tracking-wide font-semibold text-[#0F1B2D] hover:text-[#E8762D] flex items-center gap-1 border border-[#E6E0D6] px-2 py-1 rounded hover:border-[#E8762D] transition-colors bg-white"
        title={it.matched ? "Katalogdan farklı ürün seç" : "Katalogda kendiniz arayın"}
      >
        <Wand2 className="w-3 h-3" />
        {it.matched ? "Değiştir" : "Katalogda Ara"}
      </button>
      {(!it.matched || it.price_pending) && (
        <button
          type="button"
          onClick={() => openAdminNote(i)}
          disabled={requestingItem === i || busyItem(it)}
          className={`text-[10px] uppercase tracking-wide font-semibold flex items-center gap-1 border px-2 py-1 rounded transition-colors ${
            busyItem(it)
              ? "text-emerald-700 border-emerald-300 bg-emerald-50"
              : "text-white border-[#E8762D] bg-[#E8762D] hover:bg-[#D4651F]"
          } disabled:opacity-80`}
          title={it.price_pending ? "Bu ürünün fiyatını admin hazırlasın" : "Bu ürünü admin bulup eşleştirsin"}
        >
          <Send className="w-3 h-3" />
          {requestingItem === i ? "Gönderiliyor" : busyItem(it) ? "Admin Bakıyor" : it.price_pending ? "Fiyat İste" : "Admin'e Sor"}
        </button>
      )}
    </div>
  );

  return (
    <div className="min-h-screen bg-[#F7F4EF]">
      {/* Header */}
      <header className="sticky top-0 z-30 bg-[#F7F4EF]/95 backdrop-blur border-b border-[#E6E0D6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={WS_LOGO} alt="Pramid" className="h-11 sm:h-12 w-auto select-none" draggable={false} />
            <div className="hidden sm:block border-l border-[#E6E0D6] pl-3">
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#6B6F78]">
                Fiyat Çalışma Alanı
              </div>
            </div>
          </div>
          <div className="flex items-center gap-5">
            <div className="hidden md:block text-right">
              <div className="text-sm font-medium text-[#1F2937] leading-tight">
                {customer.name}
              </div>
              <div className="text-xs text-[#4B5563]">{customer.company}</div>
            </div>
            {sessionOk && (
              <Button variant="outline" size="sm" onClick={openMyQuotes} className="border-[#E6E0D6] bg-white text-[#0F1B2D] hover:bg-[#F1ECE4]">
                <FileText className="w-4 h-4 mr-1.5" /> Tekliflerim
              </Button>
            )}
            <Button
              data-testid={WORKSPACE.logoutBtn}
              variant="ghost"
              size="sm"
              onClick={logout}
              className="text-[#4B5563] hover:text-[#0F1B2D] hover:bg-[#F1ECE4]"
            >
              <LogOut className="w-4 h-4 mr-1.5" /> Çıkış
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="mb-5 sm:mb-6">
          <h1 className="text-[28px] sm:text-[36px] leading-tight text-[#0F1B2D]" style={{ fontFamily: SERIF, fontWeight: 600 }}>
            Merhaba{customer?.name ? ` ${String(customer.name).trim().split(/\s+/)[0]}` : ""},{" "}
            <span className="text-[#E8762D]">listeni gönder, fiyatın hazır.</span>
          </h1>
          <p className="mt-1.5 text-sm text-[#6B6F78]">Metin yapıştırın, Excel, fotoğraf ya da PDF yükleyin; nakit ve kredi kartı teklifiniz dakikalar içinde hazır.</p>
        </div>
        {/* Supported brands strip — no discount info */}
        <div className="mb-6 flex flex-wrap items-center gap-2">
          <span className="text-[11px] uppercase tracking-[0.15em] text-[#4B5563] mr-2">
            Desteklenen Markalar:
          </span>
          {brands.map((b) => (
            <Badge
              key={b.id}
              variant="outline"
              className="bg-white border-[#E6E0D6] text-[#1F2937] font-medium py-1 px-3 rounded-md"
            >
              {b.name}
            </Badge>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          {/* Input panel */}
          <div className="lg:col-span-2 space-y-4">
            <Card className="border-[#E6E0D6] shadow-sm rounded-lg overflow-hidden">
              <div className="px-5 pt-5 pb-3 border-b border-[#F1ECE4]">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold text-[#0F1B2D]" style={{ fontFamily: SERIF }}>
                      Ürün Listesi
                    </h3>
                    <p className="text-xs text-[#4B5563] mt-0.5">
                      Metin, Excel, fotoğraf veya PDF ile ürün listesi girin
                    </p>
                  </div>
                  <PackageSearch className="w-5 h-5 text-[#E8762D]" />
                </div>
              </div>
              <div className="p-5">
                <Tabs value={tab} onValueChange={setTab}>
                  <TabsList className="grid grid-cols-2 sm:grid-cols-4 bg-[#F1ECE4] mb-4 h-auto">
                    <TabsTrigger
                      data-testid={WORKSPACE.textTab}
                      value="text"
                      className="data-[state=active]:bg-white data-[state=active]:text-[#0F1B2D] data-[state=active]:shadow-sm"
                    >
                      <FileText className="w-4 h-4 mr-2" /> Metin
                    </TabsTrigger>
                    <TabsTrigger
                      data-testid={WORKSPACE.excelTab}
                      value="excel"
                      className="data-[state=active]:bg-white data-[state=active]:text-[#0F1B2D] data-[state=active]:shadow-sm"
                    >
                      <FileSpreadsheet className="w-4 h-4 mr-2" /> Excel
                    </TabsTrigger>
                    <TabsTrigger
                      value="photo"
                      className="data-[state=active]:bg-white data-[state=active]:text-[#0F1B2D] data-[state=active]:shadow-sm"
                    >
                      <Camera className="w-4 h-4 mr-2" /> Fotoğraf
                    </TabsTrigger>
                    <TabsTrigger
                      data-testid={WORKSPACE.pdfTab}
                      value="pdf"
                      className="data-[state=active]:bg-white data-[state=active]:text-[#0F1B2D] data-[state=active]:shadow-sm"
                    >
                      <FileText className="w-4 h-4 mr-2" /> PDF
                    </TabsTrigger>
                  </TabsList>
                  <TabsContent value="text" className="space-y-3 mt-0">
                    <Textarea
                      data-testid={WORKSPACE.textarea}
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                      rows={14}
                      placeholder={`Her satıra bir ürün yazın, örnek:\n${SAMPLE}`}
                      className="font-mono text-sm border-[#E6E0D6] focus-visible:ring-[#E8762D] focus-visible:ring-offset-0 resize-none"
                    />
                    <div className="flex items-center justify-between gap-2">
                      <button
                        type="button"
                        onClick={() => setText(SAMPLE)}
                        className="text-xs text-[#4B5563] hover:text-[#E8762D] transition-colors flex items-center gap-1"
                      >
                        <Sparkles className="w-3 h-3" /> Örnek doldur
                      </button>
                      <span className="text-xs text-[#4B5563]">
                        {text.split("\n").filter((l) => l.trim()).length} satır
                      </span>
                    </div>
                    <Button
                      data-testid={WORKSPACE.calculateBtn}
                      onClick={calculate}
                      disabled={loading || resuming}
                      className="w-full h-11 bg-[#E8762D] hover:bg-[#D4651F] text-white font-medium uppercase tracking-wide text-xs"
                    >
                      <Calculator className="w-4 h-4 mr-2" />
                      {loading ? "Hesaplanıyor…" : "Fiyatlandır"}
                    </Button>
                  </TabsContent>
                  <TabsContent value="excel" className="space-y-3 mt-0">
                    <label className="block border-2 border-dashed border-[#E6E0D6] rounded-md p-8 text-center hover:border-[#E8762D] hover:bg-[#FFF7ED]/30 transition-colors cursor-pointer">
                      <input
                        data-testid={WORKSPACE.excelInput}
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={(e) => setFile(e.target.files?.[0])}
                        className="hidden"
                      />
                      <Upload className="w-8 h-8 mx-auto mb-2 text-[#0F1B2D]" />
                      <div className="text-sm font-medium text-[#1F2937]">
                        {file ? file.name : "Excel dosyası seçin"}
                      </div>
                      <div className="text-xs text-[#4B5563] mt-1">
                        .xlsx veya .xls
                      </div>
                    </label>
                    <Button
                      data-testid={WORKSPACE.excelUploadBtn}
                      onClick={uploadExcel}
                      disabled={loading || resuming || !file}
                      className="w-full h-11 bg-[#E8762D] hover:bg-[#D4651F] text-white font-medium uppercase tracking-wide text-xs"
                    >
                      <Calculator className="w-4 h-4 mr-2" />
                      {loading ? "Yükleniyor…" : "Fiyatlandır"}
                    </Button>
                    <p className="text-xs text-[#4B5563] leading-relaxed">
                      Excel&apos;in her satırını ürün olarak okuruz. Miktar, ürün adı ile
                      aynı satırda olabilir. Örn: 10 ECA Proteus 24.
                    </p>
                  </TabsContent>
                  <TabsContent value="photo" className="space-y-3 mt-0">
                    <label className="block border-2 border-dashed border-[#E6E0D6] rounded-md p-8 text-center hover:border-[#E8762D] hover:bg-[#FFF7ED]/30 transition-colors cursor-pointer">
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={addPhotoFiles}
                        className="hidden"
                      />

                      <Camera className="w-8 h-8 mx-auto mb-2 text-[#0F1B2D]" />

                      <div className="text-sm font-medium text-[#1F2937]">
                        {photoFiles.length
                          ? `${photoFiles.length} fotoğraf seçildi`
                          : "Bir veya birden fazla fotoğraf seçin"}
                      </div>

                      <div className="text-xs text-[#4B5563] mt-1">
                        Galeriden çoklu seçim yapabilirsiniz · En fazla 20 fotoğraf
                      </div>
                    </label>

                    {photoFiles.length > 0 && (
                      <div className="rounded-md border border-[#E6E0D6] bg-white divide-y divide-[#E6E0D6] max-h-52 overflow-y-auto">
                        {photoFiles.map((photo, index) => (
                          <div
                            key={`${photo.name}-${photo.size}-${photo.lastModified}`}
                            className="flex items-center gap-3 px-3 py-2"
                          >
                            <div className="w-7 h-7 rounded bg-[#FFF7ED] text-[#E8762D] flex items-center justify-center text-xs font-semibold shrink-0">
                              {index + 1}
                            </div>
                            <div className="min-w-0 flex-1">
                              <div className="text-xs font-medium text-[#1F2937] truncate">
                                {photo.name}
                              </div>
                              <div className="text-[11px] text-[#6B6F78]">
                                {(photo.size / 1024 / 1024).toFixed(1)} MB
                              </div>
                            </div>
                            <button
                              type="button"
                              onClick={() => removePhotoFile(index)}
                              disabled={ocrLoading}
                              className="p-1.5 rounded hover:bg-red-50 text-[#6B6F78] hover:text-red-600 disabled:opacity-50"
                              title="Bu fotoğrafı kaldır"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    <Button
                      onClick={uploadPhoto}
                      disabled={ocrLoading || resuming || photoFiles.length === 0}
                      className="w-full h-11 bg-[#E8762D] hover:bg-[#D4651F] text-white font-medium uppercase tracking-wide text-xs"
                    >
                      <Camera className="w-4 h-4 mr-2" />
                      {ocrLoading
                        ? `${photoFiles.length} fotoğraf okunuyor ve fiyatlandırılıyor…`
                        : photoFiles.length > 1
                          ? `${photoFiles.length} Fotoğrafı Toplu Fiyatlandır`
                          : "Fotoğrafı Fiyatlandır"}
                    </Button>

                    <p className="text-xs text-[#4B5563] leading-relaxed">
                      Seçtiğiniz tüm fotoğraflar tek seferde yüklenir. Her fotoğraf ayrı okunur;
                      ürün satırları seçim sırasıyla tek listede birleştirilir ve tek teklif olarak fiyatlandırılır.
                    </p>
                  </TabsContent>
                  <TabsContent value="pdf" className="space-y-3 mt-0">
                    <label className="block border-2 border-dashed border-[#E6E0D6] rounded-md p-8 text-center hover:border-[#E8762D] hover:bg-[#FFF7ED]/30 transition-colors cursor-pointer">
                      <input
                        data-testid={WORKSPACE.pdfInput}
                        type="file"
                        accept="application/pdf,.pdf"
                        onChange={(e) => setPdfFile(e.target.files?.[0])}
                        className="hidden"
                      />

                      <FileText className="w-8 h-8 mx-auto mb-2 text-[#0F1B2D]" />

                      <div className="text-sm font-medium text-[#1F2937]">
                        {pdfFile ? pdfFile.name : "PDF dosyası seçin"}
                      </div>

                      <div className="text-xs text-[#4B5563] mt-1">
                        Dijital veya taranmış PDF • tüm sayfalar okunur
                      </div>
                    </label>

                    <Button
                      data-testid={WORKSPACE.pdfUploadBtn}
                      onClick={uploadPdf}
                      disabled={pdfLoading || resuming || !pdfFile}
                      className="w-full h-11 bg-[#E8762D] hover:bg-[#D4651F] text-white font-medium uppercase tracking-wide text-xs"
                    >
                      <FileText className="w-4 h-4 mr-2" />
                      {pdfLoading ? "PDF okunuyor ve fiyatlandırılıyor…" : "PDF'den Fiyatlandır"}
                    </Button>

                    <p className="text-xs text-[#4B5563] leading-relaxed">
                      PDF Gemini 2.5 Flash ile okunur. Ürün satırları mevcut V14.1 matcher akışına gönderilir; belgedeki olmayan bilgi eklenmez.
                    </p>
                  </TabsContent>
                </Tabs>

                {(loading || ocrLoading || pdfLoading || resuming) && quoteProgress && (
                  <div className="mt-5 rounded-lg border border-[#FED7AA] bg-[#FFF7ED] p-4">
                    <div className="flex items-center justify-between gap-3 mb-2">
                      <div className="min-w-0">
                        <div className="text-xs font-semibold text-[#9A3412] truncate">
                          {quoteProgress.stage || "İşleniyor"}
                        </div>
                        {quoteProgress.detail && (
                          <div className="text-[11px] text-[#7C2D12]/75 mt-0.5 truncate">
                            {quoteProgress.detail}
                          </div>
                        )}
                      </div>
                      <div className="text-lg font-bold tabular-nums text-[#E8762D] shrink-0">
                        %{Math.round(Number(quoteProgress.percent || 0))}
                      </div>
                    </div>
                    <div className="h-2.5 w-full overflow-hidden rounded-full bg-white border border-[#FED7AA]">
                      <div
                        className="h-full rounded-full bg-[#E8762D] transition-[width] duration-300 ease-out"
                        style={{ width: `${Math.max(1, Math.min(100, Number(quoteProgress.percent || 0)))}%` }}
                      />
                    </div>
                    <div className="mt-2 text-[10px] text-[#9A3412]/70">
                      Liste büyüklüğüne göre işlem süresi değişebilir. Sayfa yenilenirse teklif kaybolmaz; bu sayfaya dönünce ekrana gelir.
                    </div>
                  </div>
                )}
              </div>
            </Card>

            {exportCard && isDesktop && <div className="sticky top-20">{exportCard}</div>}
          </div>

          {/* Results */}
          <div className="lg:col-span-3 space-y-4">
            {/* Summary cards */}
            {quote && (
              <div
                data-testid="workspace-summary-cards"
                className="hidden sm:grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3"
              >
                <SummaryCard
                  label="Toplam Kalem"
                  value={quote.summary?.total_items ?? quote.items.length}
                />
                <SummaryCard
                  label="Eşleşen"
                  value={quote.summary?.matched_items ?? quote.items.filter(i => i.matched).length}
                  accent="green"
                />
                <SummaryCard
                  label="Eşleşmeyen"
                  value={quote.summary?.unmatched_items ?? quote.items.filter(i => !i.matched).length}
                  accent={(quote.summary?.unmatched_items ?? 0) > 0 ? "red" : "muted"}
                />
                <SummaryCard
                  label="Fiyat Bekleyen"
                  value={quote.summary?.price_pending_items ?? quote.items.filter(i => i.price_pending).length}
                  accent={(quote.summary?.price_pending_items ?? 0) > 0 ? "orange" : "muted"}
                />
                <SummaryCard
                  label="Liste Toplamı"
                  value={fmtTRY(quote.totals.list)}
                  small
                />
                <SummaryCard
                  label="Nakit Toplamı"
                  value={fmtTRY(quote.totals.cash)}
                  accent="orange"
                  small
                />
                <SummaryCard
                  label="Kart Toplamı"
                  value={fmtTRY(quote.totals.card)}
                  small
                />
              </div>
            )}

            {quote && quote.summary?.is_draft && (
              <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
                <strong>Teklifte tamamlanması gereken kalemler var.</strong>{" "}
                {quote.summary?.price_pending_items > 0 && `${quote.summary.price_pending_items} ürün fiyat bekliyor. `}
                {quote.summary?.unmatched_items > 0 && `${quote.summary.unmatched_items} ürün eşleşmedi. `}
                Her problemli ürünün kendi satırından <strong>Admin'e Sor</strong> diyebilirsiniz. İsterseniz katalogda kendiniz de arayabilirsiniz. PDF/Excel taslak olarak her zaman alınabilir.
              </div>
            )}

            <Card id="ws-results" className="border-[#E6E0D6] shadow-sm rounded-lg overflow-hidden scroll-mt-20">
              <div className="px-5 pt-5 pb-3 border-b border-[#F1ECE4] flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-[#0F1B2D]" style={{ fontFamily: SERIF }}>
                    Fiyat Sonuçları
                  </h3>
                  <p className="text-xs text-[#4B5563] mt-0.5">
                    {quote ? `${quote.items.length} kalem` : "Sonuçlar burada görünecek"}
                  </p>
                </div>
                {quote && (
                  <Badge className="bg-[#0F1B2D] text-white hover:bg-[#0F1B2D] rounded-sm font-mono">
                    {quote.id.slice(0, 8).toUpperCase()}
                  </Badge>
                )}
              </div>

              {!quote && (
                <div className="p-12 text-center">
                  <div className="w-16 h-16 mx-auto bg-[#F1ECE4] rounded-md flex items-center justify-center mb-4">
                    <Calculator className="w-7 h-7 text-[#0F1B2D]" />
                  </div>
                  <h4 className="text-base font-semibold text-[#0F1B2D] mb-1">
                    Fiyatlandırma için ürün listesi gerekli
                  </h4>
                  <p className="text-sm text-[#4B5563] max-w-sm mx-auto leading-relaxed">
                    Sol panelden ürünlerinizi yapıştırın veya Excel yükleyin.
                    Sistem otomatik olarak markaları ve fiyatları bulup hesaplayacaktır.
                  </p>
                </div>
              )}

              {quote && (
                <div className="md:hidden divide-y divide-[#F1ECE4]">
                  {quote.items.map((it, i) => (
                    <div key={i} className={`px-4 py-3 ${!it.matched ? "bg-red-50/40" : it.price_pending ? "bg-amber-50/60" : ""}`}>
                      <div className="flex items-start gap-2">
                        <span className="text-[#9CA3AF] text-[11px] font-mono pt-0.5">{String(i + 1).padStart(2, "0")}</span>
                        <div className="flex-1 min-w-0">
                          <div className="text-xs text-[#6B6F78] break-words">{it.searched}</div>
                          {it.matched ? (
                            <div className="font-medium text-[#1F2937] leading-snug break-words mt-0.5">
                              {it.product_name}
                              {it.price_pending && (
                                <span className="ml-1.5 inline-block text-[9px] uppercase tracking-wide text-amber-800 font-semibold bg-amber-100 px-1.5 py-0.5 rounded align-middle">Fiyat bekliyor</span>
                              )}
                            </div>
                          ) : (
                            <div className="flex items-center gap-1.5 text-[#DC2626] mt-0.5">
                              <CircleAlert className="w-3.5 h-3.5 shrink-0" />
                              <span className="text-sm font-medium">Eşleşme bulunamadı</span>
                            </div>
                          )}
                          {!it.matched && it.review_reason && <div className="mt-1 text-xs text-amber-800">{it.review_reason}</div>}
                          {it.matched && (
                            <div className="text-[11px] text-[#6B6F78] mt-0.5">{[it.brand_name, it.product_code].filter(Boolean).join(" · ")}</div>
                          )}
                          {it.matched && it.fx?.rate && !it.price_pending && <div className="text-[11px] text-[#B85A1C]">{fxMoney(it.fx.cur, it.fx.list)} liste</div>}
                          <div className="mt-2 flex items-center justify-between gap-3 text-sm">
                            <div className="flex items-center gap-1.5 text-[#4B5563]">
                              <span className="text-[11px] uppercase tracking-wide">Miktar</span>
                              <QtyCell value={it.qty} disabled={busyItem(it)} onSave={(n) => saveItemQty(i, n)} />
                            </div>
                            {it.matched && !it.price_pending ? (
                              <div className="text-right tabular-nums leading-tight">
                                <div className="font-semibold text-[#E8762D]">{fmtTRY(it.line_cash)}</div>
                                <div className="text-[11px] text-[#6B6F78]">Kart {fmtTRY(it.line_card)} · %{Number(it.cash_discount || 0).toFixed(0)}/{Number(it.card_discount || 0).toFixed(0)}</div>
                              </div>
                            ) : <span className="text-[#9CA3AF]">—</span>}
                          </div>
                          <div className="mt-2 flex justify-end">{itemActions(it, i)}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {quote && (
                <div className="hidden md:block overflow-x-auto scroll-soft">
                  <table
                    data-testid={WORKSPACE.resultsTable}
                    className="min-w-[920px] w-full text-sm tabular-nums"
                  >
                    <thead>
                      <tr className="bg-[#F7F4EF] text-[#4B5563]">
                        <Th className="w-10">#</Th>
                        <Th className="w-[24%]">Aranan Ürün</Th>
                        <Th className="w-[26%]">Eşleşen Ürün</Th>
                        <Th className="w-[10%]">Marka</Th>
                        <Th className="w-[8%]">Kod</Th>
                        <Th className="text-right w-[6%]">Mik.</Th>
                        <Th className="text-right w-[8%]">İsk.</Th>
                        <Th className="text-right w-[9%]">Nakit</Th>
                        <Th className="text-right w-[9%]">Kart</Th>
                      </tr>
                    </thead>
                    <tbody>
                      {quote.items.map((it, i) => (
                        <tr
                          key={i}
                          className={`border-b border-[#F1ECE4] hover:bg-[#F7F4EF] transition-colors align-top ${!it.matched ? "bg-red-50/30" : it.price_pending ? "bg-amber-50/50" : ""}`}
                        >
                          <td className="px-3 py-3 text-[#9CA3AF] text-xs font-mono">
                            {String(i + 1).padStart(2, "0")}
                          </td>
                          <td className="px-3 py-3 text-[#1F2937] break-words">
                            {it.searched}
                            {!it.matched && it.review_reason && (
                              <div className="mt-1 text-xs text-amber-800">{it.review_reason}</div>
                            )}
                          </td>
<td className="px-3 py-3 break-words">
  <div className="flex items-start justify-between gap-2">
    {it.matched ? (
      <div className="font-medium text-[#1F2937] leading-snug">
        {it.product_name}
        {it.price_pending && (
          <span className="ml-1.5 inline-block text-[9px] uppercase tracking-wide text-amber-800 font-semibold bg-amber-100 px-1.5 py-0.5 rounded">
            Fiyat bekliyor
          </span>
        )}
        {it.match_via === "llm" && (
          <span className="ml-1.5 inline-block text-[9px] uppercase tracking-wide text-[#0F1B2D] font-semibold bg-[#E0E7FF] px-1.5 py-0.5 rounded">
            AI
          </span>
        )}
        {it.fx?.rate && !it.price_pending && <div className="text-[11px] font-normal text-[#B85A1C]">{fxMoney(it.fx.cur, it.fx.list)} liste</div>}
      </div>
    ) : (
      <div className="flex items-center gap-1.5 text-[#DC2626]">
        <CircleAlert className="w-3.5 h-3.5 shrink-0" />
        <span className="text-sm font-medium">Eşleşme bulunamadı</span>
      </div>
    )}

    {itemActions(it, i)}
  </div>
</td>
                          <td className="px-3 py-3 text-[#4B5563]">
                            {it.matched ? (
                              <span className="inline-flex items-center gap-1.5">
                                <span className="w-1.5 h-1.5 bg-[#E8762D] rounded-full shrink-0"></span>
                                {it.brand_name}
                              </span>
                            ) : (
                              <span className="text-[#9CA3AF]">—</span>
                            )}
                          </td>
                          <td className="px-3 py-3 text-[#4B5563] font-mono text-xs">
                            {it.product_code || <span className="text-[#9CA3AF]">—</span>}
                          </td>
                          <td className="px-3 py-3 text-right text-[#1F2937]">
                            <QtyCell
                              value={it.qty}
                              disabled={it.admin_requested_by_customer && !["completed", "cancelled"].includes(it.admin_request_status)}
                              onSave={(n) => saveItemQty(i, n)}
                            />
                          </td>
                          <td className="px-3 py-3 text-right text-[#4B5563] text-xs whitespace-nowrap">
                            {it.matched && !it.price_pending ? `%${Number(it.cash_discount || 0).toFixed(0)}/${Number(it.card_discount || 0).toFixed(0)}` : "—"}
                          </td>
                          <td className="px-3 py-3 text-right font-medium text-[#E8762D] whitespace-nowrap">
                            {it.matched && !it.price_pending ? fmtTRY(it.line_cash) : <span className="text-[#9CA3AF]">—</span>}
                          </td>
                          <td className="px-3 py-3 text-right text-[#1F2937] whitespace-nowrap">
                            {it.matched && !it.price_pending ? fmtTRY(it.line_card) : <span className="text-[#9CA3AF]">—</span>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </Card>
{quote && (
  <Card className="border-[#E6E0D6] shadow-sm rounded-lg overflow-hidden">
    <div className="px-5 pt-5 pb-3 border-b border-[#F1ECE4] flex items-center justify-between">
      <div>
        <h3 className="text-lg font-semibold text-[#0F1B2D]" style={{ fontFamily: SERIF }}>
          Ek Kalemler
        </h3>
        <p className="text-xs text-[#4B5563] mt-0.5">
          İşçilik, nakliye, proje ve montaj giderleri
        </p>
      </div>

      <Button
        type="button"
        onClick={addExtraItem}
        variant="outline"
      >
        <Plus className="w-4 h-4 mr-2" />
        Ek Kalem Ekle
      </Button>
    </div>

    <div className="p-5 space-y-3">
      {extraItems.length === 0 ? (
        <div className="text-sm text-[#9CA3AF]">
          Henüz ek kalem eklenmedi.
        </div>
      ) : (
        extraItems.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-12 gap-2 items-center"
          >
            <div className="col-span-7">
              <Input
                value={item.description}
                onChange={(e) =>
                  updateExtraItem(
                    index,
                    "description",
                    e.target.value
                  )
                }
                placeholder="İşçilik, Nakliye, Proje..."
              />
            </div>

            <div className="col-span-4">
              <Input
                value={item.amount}
                onChange={(e) =>
                  updateExtraItem(
                    index,
                    "amount",
                    e.target.value
                  )
                }
                placeholder="Tutar"
              />
            </div>

            <div className="col-span-1">
              <Button
                type="button"
                variant="ghost"
                className="px-2"
                onClick={() =>
                  removeExtraItem(index)
                }
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </div>
        ))
      )}

      {extraItems.length > 0 && (
        <>
          <Separator />

          <div className="flex justify-between items-center">
            <span className="font-medium">
              Ek Kalem Toplamı
            </span>

            <span className="font-bold text-[#E8762D]">
              {fmtTRY(extraTotal)}
            </span>
          </div>
        </>
      )}
    </div>
  </Card>
)}
            {quote && (
              <div className="text-xs text-[#4B5563] flex items-center gap-2">
                <CircleCheck className="w-3.5 h-3.5 text-[#10B981]" />
                Fiyatlar KDV hariçtir. Eşleşmeyen satırlar toplamlara dahil edilmez.
              </div>
            )}
            {quote && fxSummary(quote.items) && (
              <div className="text-xs text-[#B85A1C]">
                Döviz kuru: {fxSummary(quote.items)}. Dövizli ürünler ödeme gününün kuruyla hesaplanır.
              </div>
            )}
            {exportCard && !isDesktop && exportCard}
          </div>
        </div>
      </main>

      <Dialog open={adminNoteTarget !== null} onOpenChange={(o) => { if (!o && requestingItem === null) { setAdminNoteTarget(null); setAdminNote(""); } }}>
        <DialogContent className="bg-white max-w-lg">
          <DialogHeader>
            <DialogTitle className="text-[#0F1B2D]">{quote?.items?.[adminNoteTarget]?.price_pending ? "Fiyat İste" : "Admin'e Sor"}</DialogTitle>
            <DialogDescription>
              Adminin doğru ürünü veya fiyatı belirlemesine yardımcı olmak için bildiğiniz teknik bilgileri ekleyebilirsiniz. Not yazmak zorunlu değildir.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-2">
            <div className="text-xs text-[#4B5563] bg-[#F7F4EF] border border-[#E6E0D6] rounded-md p-3">
              <strong>Ürün:</strong> {quote?.items?.[adminNoteTarget]?.searched || "—"}
              {quote?.items?.[adminNoteTarget]?.matched && (
                <div className="mt-1"><strong>Eşleşen:</strong> {quote?.items?.[adminNoteTarget]?.product_name}</div>
              )}
            </div>
            <Textarea
              value={adminNote}
              onChange={(e) => setAdminNote(e.target.value)}
              placeholder="Ölçü, marka, model, bağlantı tipi, kullanım yeri vb. bilgileri giriniz."
              className="min-h-[120px]"
            />
            <div className="text-[11px] text-[#9EA1A8]">Boş bırakıp da gönderebilirsiniz.</div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => { setAdminNoteTarget(null); setAdminNote(""); }} disabled={requestingItem !== null}>İptal</Button>
            <Button onClick={requestItemAdmin} disabled={requestingItem !== null} className="bg-[#E8762D] hover:bg-[#D4651F] text-white">
              <Send className="w-4 h-4 mr-1.5" /> {requestingItem !== null ? "Gönderiliyor…" : "Admin'e Gönder"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <ManualMatchDialog
        key={`mm-${quote?.id}-${matchIdx}`}
        open={matchIdx !== null && !!quote}
        quote={quote}
        itemIdx={matchIdx}
        onClose={() => setMatchIdx(null)}
        onMatched={(updated) => { setQuote(updated); setMatchIdx(null); }}
      />
      <Dialog open={myOpen} onOpenChange={setMyOpen}>
        <DialogContent className="bg-white max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle style={{ fontFamily: SERIF }} className="text-2xl text-[#0F1B2D]">Tekliflerim</DialogTitle>
            <DialogDescription>Bu telefonla aldığınız teklifler (site ve WhatsApp)</DialogDescription>
          </DialogHeader>
          {myQuotes === null ? <div className="text-sm text-[#6B7280]">Yükleniyor…</div> : !myQuotes.length ? (
            <div className="text-sm text-[#6B7280]">Henüz teklifiniz yok.</div>
          ) : (
            <div className="divide-y divide-[#F0EBE3]">
              {myQuotes.map((q) => (
                <div key={q.id} className="py-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:justify-between">
                  <div className="min-w-0">
                    <div className="font-medium text-[#0F1B2D]">{q.no} <span className="text-xs text-[#6B7280] font-normal">· {new Date(q.created_at).toLocaleDateString("tr-TR")} · {q.channel} · {q.items} kalem</span></div>
                    <div className="text-xs text-[#4B5563]">Nakit {fmtTRY(q.cash_total)} · Kart {fmtTRY(q.card_total)} <span className="text-[#9EA1A8]">(KDV dahil)</span></div>
                    <div className={`text-[11px] ${q.expired ? "text-amber-700" : "text-emerald-700"}`}>{q.expired ? `Geçerlilik doldu (${q.valid_until}) — güncel fiyat için yeni teklif alın` : `${q.valid_until} tarihine kadar geçerli`}</div>
                  </div>
                  <div className="flex gap-2 shrink-0">
                    <Button size="sm" variant="outline" onClick={() => openMyQuote(q.id)}>Aç</Button>
                    <a href={`${API}/quotes/${q.id}/pdf?mode=nakit`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-3 h-9 rounded-md border border-[#E6E0D6] text-sm hover:bg-[#F1ECE4]">Nakit PDF</a>
                    <a href={`${API}/quotes/${q.id}/pdf?mode=kart`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-3 h-9 rounded-md border border-[#E6E0D6] text-sm hover:bg-[#F1ECE4]">Kart PDF</a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

const Th = ({ children, className = "" }) => (
  <th className={`px-3 py-3 text-[10px] uppercase tracking-[0.1em] font-semibold border-b border-[#E6E0D6] text-left ${className}`}>
    {children}
  </th>
);

// 17.25: miktar hücresi — kaleme dokun, yaz, Kaydet (Enter) / Esc vazgeç
function parseQty(v) {
  const n = Number(String(v ?? "").trim().replace(/\s/g, "").replace(",", "."));
  return Number.isFinite(n) && n > 0 ? Math.round(n * 1000) / 1000 : null;
}

function QtyCell({ value, disabled, onSave }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const start = () => { if (disabled) return; setText(String(value ?? "").replace(".", ",")); setEditing(true); };
  const commit = async () => {
    if (busy) return;
    const n = parseQty(text);
    if (n === null) { toast.error("Miktar 0'dan büyük bir sayı olmalı."); return; }
    if (n === Number(value)) { setEditing(false); return; }
    setBusy(true);
    const ok = await onSave(n);
    setBusy(false);
    if (ok) setEditing(false);
  };
  if (editing) {
    return (
      <span className="inline-flex items-center gap-1 justify-end">
        <Input
          autoFocus
          value={text}
          disabled={busy}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") commit(); if (e.key === "Escape") setEditing(false); }}
          onBlur={() => { if (!busy) setEditing(false); }}
          className="h-8 w-20 px-2 text-right text-sm"
          inputMode="decimal"
        />
        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={commit} disabled={busy}
          className="text-[10px] font-semibold text-white bg-[#E8762D] hover:bg-[#D4651F] rounded px-2 py-1.5 disabled:opacity-50">
          {busy ? "…" : "Kaydet"}
        </button>
      </span>
    );
  }
  return (
    <button type="button" onClick={start} disabled={disabled}
      className="inline-flex items-center gap-1 hover:text-[#E8762D] disabled:cursor-not-allowed"
      title={disabled ? "Bu satır admine gönderildi; admin yanıtlayana kadar miktar değişmez" : "Miktarı değiştir"}>
      {value}
      {!disabled && <Pencil className="w-3 h-3 text-[#9EA1A8]" />}
    </button>
  );
}

function SummaryCard({ label, value, accent = "default", small = false }) {
  const accentClasses = {
    default: "text-[#1F2937]",
    green: "text-[#059669]",
    red: "text-[#DC2626]",
    orange: "text-[#E8762D]",
    muted: "text-[#9CA3AF]",
  };
  return (
    <div className="bg-white border border-[#E6E0D6] rounded-md px-3 py-2.5 shadow-sm">
      <div className="text-[10px] uppercase tracking-[0.1em] text-[#4B5563] font-medium mb-1 leading-tight">
        {label}
      </div>
      <div
        className={`font-bold tabular-nums leading-tight ${accentClasses[accent]} ${
          small ? "text-sm" : "text-2xl"
        }`}
      >
        {value}
      </div>
    </div>
  );
}

function TotalRow({ label, value, accent = false, testId }) {
  return (
    <div className="flex items-center justify-between" data-testid={testId}>
      <span className="text-xs uppercase tracking-wide text-[#4B5563]">{label}</span>
      <span className={`tabular-nums ${accent ? "text-xl font-bold text-[#E8762D]" : "text-base font-semibold text-[#1F2937]"}`}>
        {fmtTRY(value)}
      </span>
    </div>
  );
}

function ManualMatchDialog({ open, quote, itemIdx, onClose, onMatched }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [searchMessage, setSearchMessage] = useState("");
  const searchRequest = useRef(0);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const item = quote && typeof itemIdx === "number" ? quote.items[itemIdx] : null;

  useEffect(() => {
    if (!open || !item) return;
    const initial = (item.searched || "").replace(/^\d+(?:[.,]\d+)?\s*(adet|metre|m|kg|takım|takim|paket|kutu)?\s*/i, "").trim();
    setQ(initial);
    setSelectedId(null);
    runSearch(initial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const runSearch = async (query) => {
    const requestId = ++searchRequest.current;
    setSelectedId(null);
    setSearchMessage("");
    if (!String(query || "").trim()) { setResults([]); setLoading(false); return; }
    setLoading(true);
    try {
      const res = await api.get("/products/search", { params: { q: query, context: item?.searched || "", limit: 40 } });
      if (requestId !== searchRequest.current) return;
      const data = res.data;
      setResults(Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : []);
      setSearchMessage(Array.isArray(data) ? "" : String(data?.message || ""));
    } catch {
      if (requestId !== searchRequest.current) return;
      setResults([]);
      setSearchMessage("Katalog araması tamamlanamadı. Yeniden deneyin.");
    } finally {
      if (requestId === searchRequest.current) setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => runSearch(q), 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, open]);

  useEffect(() => () => { searchRequest.current += 1; }, [open]);

  const confirm = async () => {
    if (!selectedId) return toast.error("Bir ürün seçin.");
    setSaving(true);
    try {
      const res = await api.post(`/quotes/${quote.id}/items/${itemIdx}/select`, {
        product_id: selectedId,
      });
      toast.success("Seçtiğiniz ürün listeye uygulandı.");
      onMatched(res.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Eşleştirme başarısız.");
    } finally {
      setSaving(false);
    }
  };

  if (!open || !item) return null;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-[#0F1B2D] flex items-center gap-2">
            <Wand2 className="w-4 h-4 text-[#E8762D]" />
            Katalogdan Ürün Seç
          </DialogTitle>
          <DialogDescription className="text-[#4B5563] text-xs">
            <span className="text-[#1F2937] font-medium">Aranan:</span> {item.searched}. Arama teknik ölçüleri, DN/inch eşdeğerlerini ve yaygın saha yazımlarını dikkate alır.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#9CA3AF]" />
            <Input
              data-testid={MANUAL_MATCH.searchInput}
              autoFocus
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Örn: 125 uzun tirifonlu kelepçe, 50x50 te çatal, ürün kodu…"
              className="pl-9 border-[#E6E0D6]"
            />
          </div>
          <div className="flex items-center justify-between text-[11px] text-[#6B6F78] px-0.5">
            <span>{loading ? "Katalog taranıyor…" : `${results.length} uygun katalog ürünü gösteriliyor`}</span>
            <span>Ölçü + tip uyumu önce gelir</span>
          </div>
          <div
            data-testid={MANUAL_MATCH.resultsList}
            className="border border-[#E6E0D6] rounded-md max-h-80 overflow-y-auto scroll-soft divide-y divide-[#F1ECE4]"
          >
            {loading ? (
              <div className="p-6 text-center text-sm text-[#4B5563]">Aranıyor…</div>
            ) : results.length === 0 ? (
              <div className="p-6 text-center text-sm text-[#9CA3AF]">{searchMessage || <>Bu ifadeyle katalog ürünü bulunamadı. Aramayı sadeleştirebilir veya satırdaki <strong>Admin'e Sor</strong> seçeneğini kullanabilirsiniz.</>}</div>
            ) : (
              results.map((p) => (
                <button
                  key={p.id}
                  type="button"
                  data-testid={`manual-match-result-${p.id}`}
                  onClick={() => setSelectedId(p.id)}
                  className={`w-full text-left px-3 py-2.5 flex items-center gap-3 transition-colors ${
                    selectedId === p.id
                      ? "bg-[#FFF7ED] border-l-4 border-l-[#E8762D]"
                      : "hover:bg-[#F7F4EF] border-l-4 border-l-transparent"
                  }`}
                >
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-[#1F2937] flex items-center gap-2 min-w-0">
                      <span className="truncate">{p.name}</span>
                      {p.recommended && (
                        <span className="shrink-0 text-[9px] uppercase tracking-wide bg-emerald-100 text-emerald-700 px-1.5 py-0.5 rounded">En uygun</span>
                      )}
                    </div>
                    <div className="text-[11px] text-[#4B5563] flex items-center gap-2 mt-0.5">
                      <span className="inline-flex items-center gap-1">
                        <span className="w-1.5 h-1.5 bg-[#E8762D] rounded-full" />
                        {p.brand_name}
                      </span>
                      {p.code && (
                        <span className="font-mono text-[10px]">· {p.code}</span>
                      )}
                      {p.search_reason && (
                        <span className="text-emerald-700">· {p.search_reason}</span>
                      )}
                      {Number.isFinite(Number(p.search_score)) && (
                        <span className="text-[#9EA1A8]">· skor {Number(p.search_score).toFixed(0)}</span>
                      )}
                    </div>
                  </div>
                  <div className="text-sm tabular-nums text-[#1F2937] font-medium whitespace-nowrap">
                    {Number(p.list_price || 0) > 0 ? fmtTRY(p.list_price) : <span className="text-amber-700 text-xs">Fiyat bekliyor</span>}
                  </div>
                </button>
              ))
            )}
          </div>
          <div className="flex items-center justify-between gap-3 pt-1">
            <p className="text-[11px] text-[#9CA3AF]">
              Mevcut miktar ({item.qty}) korunur ve seçtiğiniz ürünle yeniden hesaplanır.
            </p>
            <div className="flex gap-2">
              <Button variant="outline" onClick={onClose}>İptal</Button>
              <Button
                data-testid={MANUAL_MATCH.confirmBtn}
                onClick={confirm}
                disabled={!selectedId || saving}
                className="bg-[#E8762D] hover:bg-[#D4651F] text-white"
              >
                {saving ? "Kaydediliyor…" : "Ürünü Seç"}
              </Button>
            </div>
          </div>
        </div>
            </DialogContent>
    </Dialog>
  );
}

// PRAMID V15.7.1: additive Excel sheet selection
import "@/addons/excelSheetAddon";
